// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>37</span>&nbsp;&nbsp;Turn away my eyes lest they gaze on vanities;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;O give me life in your ways.<br> </p> </div></div>";
// Exports
module.exports = code;